import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import Icon from 'dpl/common/components/Icon';
import { isMobileUA } from 'dpl/shared/utils';

const IS_MOBILE_UA = isMobileUA();

/** @param {any} props */
export default function VideoIconOverlay({
  className = null,
  containerClassName = null,
  style = null,
  isPlaying = false,
  height = '24px',
  width = '24px'
}) {
  const [opacity, setOpacity] = useState(1);

  let timerId = null;

  useEffect(() => {
    if (!IS_MOBILE_UA) return null;

    // On desktop, when the video starts playing and the mouse leaves the puppy card,
    // the play video icon overlay is hidden. If the puppy card is hovered while the
    // video is still playing, the pause video overlay icon is shown instead.
    // On mobile, since the hover state works differently, this behavior needs to be
    // emulated using JavaScript.
    if (isPlaying) {
      timerId = setTimeout(() => {
        setOpacity(0);
      }, 300);
    } else {
      clearTimeout(timerId);
      setOpacity(1);
    }

    return () => {
      clearTimeout(timerId);
    };
  }, [isPlaying]);

  return (
    <div
      className={classnames(
        'VideoIconOverlay flex items-center justify-center transition',
        { 'VideoIconOverlay--playing': !IS_MOBILE_UA && isPlaying },
        className
      )}
      style={{ opacity: IS_MOBILE_UA ? opacity : null, ...style }}
      aria-hidden
    >
      <div
        className={classnames(
          'VideoIconOverlay__container inline-flex items-center justify-center white pt3 pb3 pr3 pl3 br-100',
          containerClassName
        )}
      >
        <Icon
          name={isPlaying ? 'fetch-pause' : 'fetch-play'}
          height={height}
          width={width}
        />
      </div>
    </div>
  );
}

VideoIconOverlay.propTypes = {
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  isPlaying: PropTypes.bool,
  height: PropTypes.string,
  width: PropTypes.string,
  style: PropTypes.shape({
    left: PropTypes.string,
    bottom: PropTypes.string
  })
};
